// @flow

import StateListenerRegistry from '../../../../../react/features/base/redux/StateListenerRegistry';

/**
 * Listens for changes in the hints settings state to init hints.
 */
StateListenerRegistry.register(
    /* selector */ state => state['wildix/features/hints'].enabled,
    /* listener */ enabled => {
        APP.wildix.speakersInfo.clear(enabled);
    }
);

/**
 * Listens for changes in the participants state to handle when user stay alone.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/base/participants'].remote.size,
    /* listener */ (size, store, prevSize) => {

        if (size === 0 && prevSize) {
            APP.wildix.speakersInfo.clear(false);
        }
    }
);

